module.exports = __webpack_public_path__ + "media/images/deceased-8179d4091eceab97619f1ae6afcdd599.svg";